import React from 'react';

import s from './button.module.scss';
import cn from "classnames";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary';
    start?: React.ReactNode;
    end?: React.ReactNode;
};

export const Button: React.FC<ButtonProps> = (props) => {
    const variant = props.variant || 'primary';
    
    const renderSide = (side: 'start' | 'end') => {
        
        if (props[side]) {
            return props[side] instanceof String ? props[side] : props[side]
        }
        return null;
    }
    
    return (
        <button
            {...props}
            className={cn(
                s['button'],
                props.className || '',
                {
                    [s['button--disabled']]: props.disabled,
                    [s[`button--${variant}`]]: !!variant,
                    [s['button--with-start']]: !!props.start,
                    [s['button--with-end']]: !!props.end,
                }
            )}
        >
            {renderSide('start')}
            {props.children}
            {renderSide('end')}
        </button>
    );
};
